import { subscribeToCookieConsentChange } from '%paysera_service_agreement/js/CookiesUserAgreement/service/cookieConsentChangeNotifier';
import initPostHog from './initPostHog';

const subscribePostHogToConsent = appSettings => subscribeToCookieConsentChange(() => {
    initPostHog(appSettings);
});

export default subscribePostHogToConsent;
